import { render, staticRenderFns } from "./ManageWaitlist.vue?vue&type=template&id=6831cbda&"
import script from "./ManageWaitlist.vue?vue&type=script&lang=js&"
export * from "./ManageWaitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports